import { validatorRequiredField } from "../validator/requiredField"

export const requiredField = (isRequired?: boolean) =>
  isRequired ? [validatorRequiredField] : []
